import React, { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';

import { useUserUid } from '../../hooks/useUserUid';

const applicationId = '2d52a226-3d6c-4ec8-859f-b77a33b29011';
const clientToken = 'pub0659587cdce54a0ed4687e965b49cf45';

if (process.env.NODE_ENV !== 'development') {
  datadogRum.init({
    applicationId,
    clientToken,
    site: 'datadoghq.com',
    service: 'cap',
    env: process.env.REACT_APP_DEPLOY_ENV,
    version: process.env.APP_VERSION,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    allowedTracingUrls: [
      {
        // Same-origin requests
        match: (url: string) => url.startsWith(window.location.origin),
        propagatorTypes: ['tracecontext', 'datadog'],
      },
      {
        match: (url: string) => url.startsWith('https://cortex.bighealth.com/'),
        propagatorTypes: ['tracecontext', 'datadog'],
      },
      {
        match: (url: string) => url.startsWith('https://cortex.bighealthstage.com/'),
        propagatorTypes: ['tracecontext', 'datadog'],
      },
      {
        match: (url: string) => url.startsWith('https://cortex.bighealthdev.com/'),
        propagatorTypes: ['tracecontext', 'datadog'],
      },
    ],
    beforeSend: (event) => {
      if (event.type === 'resource') {
        const { url } = event.resource;
        if (/posthog\.com|sentry\.io|singular\.net/.test(url)) {
          return false;
        }
      }
      return true;
    },
    plugins: [reactPlugin({ router: false })],
  });
}

const DatadogInit: React.FC = () => {
  const { userUid } = useUserUid();

  useEffect(() => {
    if (userUid) {
      datadogRum.setUser({ id: userUid });
    } else {
      datadogRum.clearUser();
    }
  }, [userUid]);

  return null;
};

export default DatadogInit;
